module.exports = __webpack_public_path__ + "media/images/about/b_2-f57df81eb9c7b791e18f69acb8f69815.png";